import React from 'react'
import PropTypes from 'prop-types'
import { Footer, Header } from 'components'

const General = ({ children, showHeader, showFooter }) => (
  <div className="flex flex-col">
    {showHeader && <Header />}
    <main>
      {children}
      {showFooter && <Footer />}
    </main>
  </div>
)

General.propTypes = {
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
}
General.defaultProps = {
  showHeader: true,
  showFooter: true,
}

export default General
